import React, { useContext, useEffect, useState } from "react";
import { CircularProgress, Grid } from "@mui/material";
import { useLocation } from "react-router-dom";
import GoToTop from "components/ui/GoToTop";
import { ReactComponent as Background } from "assets/icons/bg.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDesings } from "features/Category/categoryProd/api/get-desings";
import SortContext from "context/SortContext";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import { transformData } from "utils/transformdata";
import SingleProduct from "./SingleProduct";
import { SettingContext } from "context/SettingContext";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { useInView } from "react-intersection-observer";
import { useGlobalContext } from "context/GlobalContext";
import { useFilter } from "context/FilterContext";
import DataNotFound from "components/ui/datanotfound/DataNotFound";
import apiClient from "lib/api-client";

const RestrictProductPage = () => {
  const location = useLocation();

  // const { search } = React.useContext(SortContext);
  const categoryName = location.state?.name[1];
  const subCategoryName = location.state?.name[2]?.split("-")[0]?.trim();
  const permission = usePermissions();

  const hasAccessToUnrestict = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Restricted Designs"), "unrestict");
  // const hasAccessToSee = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Settings", permission), "Restricted Designs"), "edit");
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.2,
  });
  // const {setRestrictBtn}= useContext(SettingContext)
  const { setSyncButtonName, setSyncButton, search, setSearch, searchBar, setSearchBar } = useContext(SettingContext);
  const { isFilter, setFilter, setFilterValues, setBackendFilterValues, filterValues, setAppliedFilterValues } = useFilter();
  const { setSearchPlaceHolder } = useGlobalContext();
  const [restrictCategoryData, setRestrictCategoryData] = useState([]);
  const {
    setSortOptions,
    sortValue,
    sortOptions,
    setSortValue,
    setFilterChangeCount,
    setDisplayCount,
    setFilterChangeDesignCount,
    setSearchResultCount,
    filterChangeCount,
    setDynamicFilterCount,
    dynamicfilterCount,
  } = useGlobalContext();

  const selectedOption = sortOptions.find((option) => option.id == sortValue);
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;

  // const hasAccessToSeeSales = hasAccessPage(findSpecificPage("Sales Count", permission), "vie
  
  const hasAccessToYearlySalesData = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sales By year"), "view");
  const hasAccessToClientSalesData = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sales By Client"), "view");
  const hasAccessToSeeSales = hasAccessToYearlySalesData || hasAccessToClientSalesData;
  let isAutoRestrict = filterValues && filterValues["Restricted Type"];

  const diamondPieces = filterValues?.["Diamond Pieces"]?.length > 0 ? filterValues["Diamond Pieces"] : "";
  const diamondWeight = filterValues?.["Diamond Weight"]?.length > 0 ? filterValues["Diamond Weight"] : "";
  const goldGrossWeight = filterValues?.["Gold Gross-Weight"]?.length > 0 ? filterValues["Gold Gross-Weight"] : "";
  const goldNetWeight = filterValues?.["Gold Net-Weight"]?.length > 0 ? filterValues["Gold Net-Weight"] : "";
  const ratio = filterValues?.["Ratio"]?.length > 0 ? filterValues["Ratio"] : "";
  const designCreateDate = filterValues?.["Design Create Date"] || [];

  useEffect(() => {
    if (hasAccessToUnrestict) {
      // setRestrictBtn(hasAccessToSee)
      setSyncButton(hasAccessToUnrestict);
      setSyncButtonName("unrestrict");
    }
    setSearchBar(true);
    return () => {
      // setRestrictBtn(false)
      setSyncButton(false);
      setSyncButtonName(null);
      setSearchBar(false);
    };
  }, [hasAccessToUnrestict]);

  useEffect(() => {
    if (sessionStorage.getItem("appliedSortValue") > 0) {
      setSortValue(sessionStorage.getItem("appliedSortValue"));
    }

    setSortOptions([
      { id: 1, name: "Design No. (Low to High)", sortBy: "Design No.", order: "asc" },
      { id: 2, name: "Design No. (High to Low)", sortBy: "Design No.", order: "desc" },
      { id: 3, name: "Design Date (Oldest to Newest)", sortBy: "Design Date", order: "asc" },
      { id: 4, name: "Design Date (Newest to Oldest)", sortBy: "Design Date", order: "desc" },
      { id: 5, name: "Restricted Date (Oldest to Newest)", sortBy: "Restricted Date", order: "asc" },
      { id: 6, name: "Restricted Date (Newest to Oldest)", sortBy: "Restricted Date", order: "desc" },
      { id: 7, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
      { id: 8, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },
      { id: 9, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
      { id: 10, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
      { id: 11, name: "Sales (Low to High)", sortBy: "Sales", order: "asc", access: hasAccessToSeeSales },
      { id: 12, name: "Sales (High to Low)", sortBy: "Sales", order: "desc", access: hasAccessToSeeSales },
      { id: 13, name: "Ratio (Low to High)", sortBy: "Ratio", order: "asc", access: true },
      { id: 14, name: "Ratio (High to Low)", sortBy: "Ratio", order: "desc", access: true },
    ]);
    setFilter(true);

    const baseFilterData = {
      "Restricted Type": ["Both"],
      "Diamond Pieces": [0, 100],
      "Diamond Weight": [0, 100],
      "Gold Gross-Weight": [0, 100],
      "Gold Net-Weight": [0, 100],
      Ratio: [0, 100],
      "Design Create Date": [],
    };
    let backendOptions = { ...baseFilterData };
          delete backendOptions["Restricted Type"];
    setBackendFilterValues(backendOptions);

    if (sessionStorage.getItem("filterChangeCount") == 0) {
      setFilterValues(baseFilterData);
    } else {
      const savedFilters = JSON.parse(sessionStorage.getItem("appliedFilterValues") || "{}");
      setFilterValues({ ...baseFilterData, ...savedFilters });
    }
    setSearchPlaceHolder("Search By Design Number");
    return () => {
      setSearch("");
      setSortOptions([]);
      setSortValue(null);
      setFilter(false);
      setFilterValues({
        "Restricted Type": [],
        "Diamond Pieces": [],
        "Diamond Weight": [],
        "Gold Gross-Weight": [],
        "Gold Net-Weight": [],
        Ratio: [],
      });
      setSearchPlaceHolder("");
      setBackendFilterValues({});
      setAppliedFilterValues({});
      sessionStorage.removeItem("appliedSortValue");
      setDynamicFilterCount(true);
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem("appliedSortValue", sortValue);
  }, [sortValue, sortOptions]);

  useEffect(() => {
    const fetchSliderData = async () => {
      try {
        const response = await apiClient.post(`/api/v1/collection/getDesignSlidersData`, {
          categoryName,
          subCategoryName,
          isRestricted: true,
          isHidden: false,
        });
        if (response?.status === 200) {
          const { diamondPieces, diamondWeight, grossWeight, netWeight, ratio } = response.data.data;
          const sliderData = {
            "Diamond Pieces": diamondPieces || [0, 100],
            "Diamond Weight": diamondWeight || [0, 100],
            "Gold Gross-Weight": grossWeight || [0, 100],
            "Gold Net-Weight": netWeight || [0, 100],
            Ratio: ratio || [0, 100],
          };
          setBackendFilterValues((prev) => ({ ...prev, ...sliderData }));
          if (sessionStorage.getItem("filterChangeCount") == 0) {
            setFilterValues((prev) => ({ ...prev, ...sliderData }));
          } else {
            const savedFilters = JSON.parse(sessionStorage.getItem("appliedFilterValues") || "{}");
            setFilterValues((prev) => ({ ...prev, ...sliderData, ...savedFilters }));
          }
        }
      } catch (error) {
        console.error("Error fetching slider data:", error);
      }
    };
    fetchSliderData();
  }, []);

  useEffect(() => {
    setSearch("");
  }, [location]);

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, error } = useDesings({
    limit: 30,
    categoryName,
    subCategoryName,
    search,
    isRestric: true,
    sortBy: selectedSortBY,
    sortOrder: selectedSortOrder,
    isRestrictType: isAutoRestrict,
    diamondPieces,
    diamondWeight,
    goldGrossWeight,
    goldNetWeight,
    ratio,
    designCreateDate,
    isHidden: false,
  });

  // useEffect(() => {
  //   setFilterChangeCount(data?.pages[0]?.totalCount);
  //   // setFilterChangeDesignCount(data?.pages[0]?.totalStyles);
  //   setDisplayCount(true);
  //   return () => {
  //     setFilterChangeCount(0);
  //     // setFilterChangeDesignCount(0);
  //     setDisplayCount(false);
  //   };
  // }, [data]);

  useEffect(() => {
    if (search === "") {
      setDynamicFilterCount(true);
    }

    if (dynamicfilterCount) {
      setSearchResultCount(data?.pages[0]?.totalCount);
      setFilterChangeCount(data?.pages[0]?.totalCount);
    } else {
      setSearchResultCount(data?.pages[0]?.totalCount);
      setFilterChangeCount(filterChangeCount);
    }
    setDisplayCount(true);
    const allProducts = data?.pages?.flatMap((page) => page?.designs);
    setRestrictCategoryData(allProducts);

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setDisplayCount(false);
    };
  }, [data]);

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage]);

  if (isLoading) return <ProductSkeleton count={10} />;

  if (isError) return <div>Error: {error.message}</div>;

  const hasNoResults =
    search &&
    data?.pages?.every(
      (page) => !page?.designs?.length
    );

  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;

  return (
    <>
      {/* <InfiniteScroll
        dataLength={data?.pages.flatMap((page) => page.designs).length || 0}
        next={fetchNextPage}
        hasMore={!!hasNextPage}
        loader={isFetchingNextPage && <CircularProgress sx={{ display: "flex", justifyContent: "center", margin: "20px auto" }} />}
        scrollThreshold={0.8}
        endMessage={<p style={{ textAlign: "center" }}></p>}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          sx={{
            flex: "1 1 1",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "30px",
            rowGap: "32px",
          }}
          className="Grid-padding"
        >
          {data?.pages?.map((page) =>
            page.designs.map((design) => {
              const transformedProduct = transformData(design);
              return <SingleProduct product={transformedProduct} key={design._id} />;
            })
          )}
        </Grid>
      </InfiniteScroll> */}

      <Grid
        container
        className="Grid-padding"
        direction="row"
        justifyContent="flex-start"
        sx={{
          flex: "1 1 1",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "30px",
          rowGap: "32px",
          // maxHeight: "78vh",
          // overflowY: "scroll",
          // "&::-webkit-scrollbar": {
          //   width: "0px",
          // },
          // "&::-webkit-scrollbar-thumb": {
          //   background: "transparent",
          // },
        }}
      >
        {data?.pages?.map((page) =>
          page.designs.map((design) => {
            const transformedProduct = transformData(design);
            return <SingleProduct product={transformedProduct} key={design._id} allData={restrictCategoryData} />;
          })
        )}
        <div ref={ref} style={{ height: "20px", marginTop: "10px" }} />
        {isFetchingNextPage && (
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <CircularProgress />
          </Grid>
        )}
      </Grid>

      <GoToTop />

      {data?.pages?.length === 0 ||
        (!data?.pages.some((page) => page?.designs?.length > 0) && (
          <div
            style={{
              display: "flex",
              textAlign: "center",
              margin: "auto",
              padding: "auto",
              justifyContent: "center",
              alignItems: "center",
              height: "78vh",
            }}
          >
            <Background />
          </div>
        ))}
    </>
  );
};

export default RestrictProductPage;
